module.exports = __webpack_public_path__ + "static/zem601l-2d319cdb79406342a1fdd11c316b28de.png";